import React from 'react';
import classNames from 'classnames';
// eslint-disable-next-line @typescript-eslint/consistent-type-imports
import {
  ContentPositionClassNames,
  ContentPosition,
  ColumnType,
} from './constants';
import { TableHeadCell } from './HeadCell';

export interface BodyItem {
  [key: string]: React.ReactNode;
}

export type CellDescription = (CellDescriptionComponent | CellDescriptionText) &
  TableHeadCell;

interface CellDescriptionMain {
  contentPosition?: ContentPosition;
  classNamesForCell?: (item: Object, row: number) => string;
  width?: string;
}

interface CellDescriptionItemMap extends CellDescriptionMain {
  rowIndex: number;
  item: BodyItem;
  correspondingKey?: string;
  columnRenderer?: (item: Object, row?: number) => JSX.Element;
}

interface CellDescriptionText extends CellDescriptionMain {
  type: ColumnType.TEXT;
  correspondingKey: string;
}

interface CellDescriptionComponent extends CellDescriptionMain {
  type: ColumnType.COMPONENT;
  columnRenderer: (item: Object, row?: number) => JSX.Element;
}

export const BodyCell: React.FC<CellDescriptionItemMap> = ({
  classNamesForCell,
  width,
  correspondingKey,
  columnRenderer,
  contentPosition,
  rowIndex,
  item,
}) => {
  const cellProps = {
    className: classNames(
      'ui-table-body-cell',
      (classNamesForCell && classNamesForCell(item, rowIndex)) || ''
    ),
    style: { width },
  };

  return (
    <td {...cellProps}>
      {(columnRenderer && columnRenderer(item, rowIndex)) || (
        <div
          className={classNames(
            'ui-table-body-cell-text',
            'link-small',
            ContentPositionClassNames[contentPosition || ContentPosition.LEFT]
          )}
        >
          <span>{correspondingKey && item[correspondingKey]}</span>
        </div>
      )}
    </td>
  );
};
